import { entity } from "simpler-state"

export const RefreshFlag = entity(false)

export function triggerRefreshFlag() {
  RefreshFlag.set(f => !f)
}
